module.exports = __webpack_public_path__ + "img/rate.7e1030f8.webp";